import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const InactiveChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  return <CalendarChip eventInfo={eventInfo} className="bg-red-500" />;
};
